import Image from "next/image";

import { formatImageUrl } from "@/components/blog/Util";
import { cn } from "@/lib/utils";
import { clashGrotesk, jakartaSans } from "@/styles/fonts";

import type { CaseStudy } from "@/pages/case-studies/[slug]";

export default function WhySection({
  whatsWorking,
  heroImage,
}: Pick<CaseStudy, "whatsWorking"> & { heroImage: string }) {
  return (
    <section
      className={cn("py-12 md:py-24 flex flex-col md:flex-row bg-white", jakartaSans.variable, clashGrotesk.variable)}
    >
      <div className="flex flex-col gap-12 md:gap-24 w-full items-center justify-center max-w-6xl mx-auto px-4">
        <div className="flex flex-col-reverse md:flex-row gap-12 md:gap-32 w-full items-center">
          <div className="w-full flex flex-col gap-8">
            <h1
              className="font-clash font-medium text-3xl md:text-4xl leading-[0.95] tracking-snug relative text-ash-900"
              itemProp="headline"
            >
              What&apos;s Working
            </h1>
            <div className="flex flex-col gap-3">
              {whatsWorking.map((item, index) => (
                <div key={index} className="flex flex-col pb-3 border-b border-ash-200 gap-1">
                  <p className="text-base text-ash-800 font-semibold">{item.fields.header}</p>
                  <p className="text-base text-ash-600 font-medium">{item.fields.subheader}</p>
                </div>
              ))}
            </div>
          </div>

          {heroImage ? (
            <div className="w-full aspect-square rounded-2xl">
              <Image
                width={200}
                height={200}
                sizes="(max-width: 768px) 90vw, 45vw"
                className="rounded-2xl shadow-sm w-full h-full object-cover"
                src={`${formatImageUrl(heroImage)}`}
                alt="Rebolt Customer Image"
                loading="eager"
                priority
              />
            </div>
          ) : (
            <div className="w-full aspect-square rounded-2xl bg-ash-800 flex items-center justify-center">
              <Image
                src="/rebolt-branding/rebolt-app-icon.png"
                alt="Rebolt Logo"
                height={500}
                width={500}
                className="w-full h-full rounded-2xl"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
